'use client';

import { useUserContext } from '@/context/user';
import { useToasts } from '@/hooks/Toasts';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useMutation } from '@apollo/client';
import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';
import { AlertCircle, Check } from 'react-feather';
import faceBookPng from '../../assets/images/rewards-program/facebook.png';
import instagramPng from '../../assets/images/rewards-program/instagram.png';
import pinterestPng from '../../assets/images/rewards-program/pinterest.png';
import succeedPng from '../../assets/images/rewards-program/succeed.png';
import tiktokPng from '../../assets/images/rewards-program/tiktok.png';
import youtubePng from '../../assets/images/rewards-program/youtube.png';
import { GET_CUSTOMER_INFORMATION } from '../AccountInformationPage/accountInformationPage.gql';
import { FOLLOW_US_SOCIAL, GET_CUSTOMER_REWARDS_BALANCE } from './gql';
import SignTip from './signTip';

const FollowUs = props => {
  const [{ isSignedIn }] = useUserContext();
  const { operationAvailableMap } = props;

  const [, { addToast }] = useToasts();
  const [loadingMap, setLoadingMap] = useState({
    facebook: false,
    instagram: false,
    youtube: false,
    pinterest: false,
    tiktok: false,
  });
  const { isMobile } = useIsMobile();

  const afterRequest = (response, isRequestOk) => {
    if (isRequestOk) {
      const isOperationOk = String(response.data?.followUsSocial.code) === '200';
      const message = response.data?.followUsSocial.content;

      addToast({
        type: isOperationOk ? 'success' : 'error',
        icon: isOperationOk ? <Check /> : <AlertCircle />,
        message,
        timeout: 5000,
      });
    } else {
      const errContent = response.networkError.result?.content || response.message;

      addToast({
        type: 'error',
        icon: <AlertCircle />,
        message: errContent,
        timeout: 5000,
      });
    }
  };

  const [reqFollowUsSocial] = useMutation(FOLLOW_US_SOCIAL, {
    errorPolicy: 'all',
    refetchQueries: [GET_CUSTOMER_INFORMATION, GET_CUSTOMER_REWARDS_BALANCE],
  });

  const handleMobileCardClick = cardConfig => {
    if (!isMobile) {
      return;
    }

    if (!isSignedIn) {
      router.push('/sign-in');

      return;
    }

    if (!cardConfig.available) {
      return;
    }

    cardConfig.btnOnClick?.();
  };

  const followUsConfigs = [
    {
      icon: (
        <Image
          src={faceBookPng}
          alt='facebook'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'FOLLOW US',
      btnText: 'FOLLOW US',
      pointDesc: '20 Points',
      loading: loadingMap.facebook,
      btnOnClick: () => {
        if (loadingMap.facebook) {
          return;
        }

        setLoadingMap(x => ({
          ...x,
          facebook: true,
        }));
        reqFollowUsSocial({
          variables: {
            type: 'facebook',
          },
        })
          .then(res => {
            afterRequest(res, true);
            setLoadingMap(x => ({
              ...x,
              facebook: false,
            }));
          })
          .catch(err => {
            afterRequest(err, false);
            setLoadingMap(x => ({
              ...x,
              facebook: false,
            }));
          });
        window.open('https://www.facebook.com/kingsyardofficial', '_blank');
      },
      available: operationAvailableMap.follow_us_facebook,
    },
    {
      icon: (
        <Image
          src={instagramPng}
          alt='instagram'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'FOLLOW US',
      btnText: 'FOLLOW US',
      pointDesc: '20 Points',
      loading: loadingMap.instagram,
      btnOnClick: () => {
        if (loadingMap.instagram) {
          return;
        }

        setLoadingMap(x => ({
          ...x,
          instagram: true,
        }));
        reqFollowUsSocial({
          variables: {
            type: 'instagram',
          },
        })
          .then(res => {
            afterRequest(res, true);
            setLoadingMap(x => ({
              ...x,
              instagram: false,
            }));
          })
          .catch(err => {
            afterRequest(err, false);
            setLoadingMap(x => ({
              ...x,
              instagram: false,
            }));
          });
        window.open('https://www.instagram.com/official_kingsyard/', '_blank');
      },
      available: operationAvailableMap.follow_us_instagram,
    },
    {
      icon: (
        <Image
          src={youtubePng}
          alt='youtube'
          width={44}
          height={40}
          className='w-[37px] lg_w-[42px]'
        />
      ),
      title: 'SUBSCRIBE US',
      btnText: 'SUBSCRIBE US',
      pointDesc: '20 Points',
      loading: loadingMap.youtube,
      btnOnClick: () => {
        if (loadingMap.youtube) {
          return;
        }

        setLoadingMap(x => ({
          ...x,
          youtube: true,
        }));
        reqFollowUsSocial({
          variables: {
            type: 'youtube',
          },
        })
          .then(res => {
            afterRequest(res, true);
            setLoadingMap(x => ({
              ...x,
              youtube: false,
            }));
          })
          .catch(err => {
            afterRequest(err, false);
            setLoadingMap(x => ({
              ...x,
              youtube: false,
            }));
          });
        window.open('https://www.youtube.com/channel/UCKUgy5OW950NA7H4XjXOJdQ/videos', '_blank');
      },
      available: operationAvailableMap.follow_us_youtube,
    },
    {
      icon: (
        <Image
          src={pinterestPng}
          alt='pinterest'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'FOLLOW US',
      btnText: 'FOLLOW US',
      pointDesc: '20 Points',
      loading: loadingMap.pinterest,
      btnOnClick: () => {
        if (loadingMap.pinterest) {
          return;
        }

        setLoadingMap(x => ({
          ...x,
          pinterest: true,
        }));
        reqFollowUsSocial({
          variables: {
            type: 'pinterest',
          },
        })
          .then(res => {
            afterRequest(res, true);
            setLoadingMap(x => ({
              ...x,
              pinterest: false,
            }));
          })
          .catch(err => {
            afterRequest(err, false);
            setLoadingMap(x => ({
              ...x,
              pinterest: false,
            }));
          });

        window.open('https://www.pinterest.com/Official_KingsYard/', '_blank');
      },
      available: operationAvailableMap.follow_us_pinterest,
    },
    {
      icon: (
        <Image
          src={tiktokPng}
          alt='tiktok'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'FOLLOW US',
      btnText: 'FOLLOW US',
      pointDesc: '20 Points',
      loading: loadingMap.tiktok,
      btnOnClick: () => {
        if (loadingMap.tiktok) {
          return;
        }

        setLoadingMap(x => ({
          ...x,
          tiktok: true,
        }));
        reqFollowUsSocial({
          variables: {
            type: 'tiktok',
          },
        })
          .then(res => {
            afterRequest(res, true);
            setLoadingMap(x => ({
              ...x,
              tiktok: false,
            }));
          })
          .catch(err => {
            afterRequest(err, false);
            setLoadingMap(x => ({
              ...x,
              tiktok: false,
            }));
          });

        window.open('https://www.tiktok.com/@kingsyard_official', '_blank');
      },
      available: operationAvailableMap.follow_us_tiktok,
    },
  ];

  return (
    <div className={props.className}>
      <div className='text-center text-sm  font-normal leading-5 text-primary lg_text-[20px] lg_leading-[22px]'>
        FOLLOW US
      </div>

      <div
        className={clsx(
          'mx-2.5 mt-[30px]  max-w-[1440px]  gap-x-[15px] gap-y-[15px] lg_gap-x-[35px] min-[1440px]_mx-auto',
          'grid grid-cols-[repeat(2,170px)] justify-center justify-items-center sm_grid-cols-[repeat(3,170px)] lg_grid-cols-[repeat(3,260px)] min-[1200px]_grid-cols-5',
        )}
      >
        {followUsConfigs.map((x, i) => {
          return (
            <div
              key={i}
              className={clsx(
                'relative h-[180px] w-full max-w-[170px] overflow-hidden rounded-[10px] lg_h-[300px] lg_max-w-[260px]',
                'border-2 border-solid border-[#efefef]  lg_border-[3px]  ',
                isSignedIn ? x.available === false && 'bg-[#efefef] lg_bg-[transparent]' : 'group lg_hover_border-none',
              )}
              onClick={() => {
                handleMobileCardClick(x);
              }}
            >
              <div
                className={clsx(
                  'mt-[25px] flex justify-center ',
                  isSignedIn && x.available ? 'lg_mt-[25px]' : 'lg_mt-[75px]',
                )}
              >
                {x.icon}
              </div>
              <div className='mt-2.5 text-center text-sm font-normal leading-5 text-primary lg_text-lg lg_leading-[22px] '>
                {x.title}
              </div>
              <div
                className={clsx(
                  'flex items-center justify-center',
                  'absolute bottom-[35px] w-full text-center font-sans text-base font-bold leading-5 text-primary lg_text-[18px] lg_font-semibold ',
                  isSignedIn && x.available ? 'lg_bottom-[125px]' : 'lg_bottom-[75px]',
                )}
              >
                {isSignedIn && x.available === false && (
                  <Image
                    src={succeedPng}
                    alt='checked'
                    width={14}
                    className={clsx('lg_hidden')}
                    height={12}
                  />
                )}
                <span className={clsx(isSignedIn && x.available === false && 'ml-[5px] lg_ml-0')}>{x.pointDesc}</span>
              </div>

              {isSignedIn && x.available ? (
                <button
                  className={clsx(
                    'absolute bottom-[30px] left-0 right-0 mx-7 hidden py-5 lg_block',
                    'text-center text-base font-normal leading-5 text-primary',
                    'bg-[#EFEFEF] active_scale-[.97] disabled_scale-100',
                    'hover_bg-primary hover_text-white',
                  )}
                  onClick={e => {
                    e.stopPropagation();
                    x.btnOnClick();
                  }}
                  disabled={x.loading}
                >
                  {x.loading ? `${x.btnText}...` : x.btnText}
                </button>
              ) : null}

              {isSignedIn ? null : <SignTip className={clsx('group-hover_lg_block')} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FollowUs;
